// Lightweight, dependency-free emoji popover. Renders a small tabbed grid from the curated
// EMOJI_GROUPS and calls onPick(emoji) — the parent inserts it into the draft.

import React, { useState } from "react";
import { EMOJI_GROUPS } from "./chatMedia";

export default function ChatEmojiPicker({ onPick, onClose }) {
  const [tab, setTab] = useState(0);
  const group = EMOJI_GROUPS[tab];
  return (
    <div style={styles.pop} role="dialog" aria-label="Emoji picker">
      <div style={styles.tabs}>
        {EMOJI_GROUPS.map((g, i) => (
          <button
            key={g.label}
            type="button"
            onClick={() => setTab(i)}
            style={{ ...styles.tab, ...(i === tab ? styles.tabActive : {}) }}
            aria-label={`Emoji group ${i + 1}`}
          >
            {g.label}
          </button>
        ))}
      </div>
      <div style={styles.grid}>
        {group.emojis.map((e) => (
          <button
            key={e}
            type="button"
            style={styles.emoji}
            onClick={() => {
              onPick(e);
              if (onClose) onClose();
            }}
          >
            {e}
          </button>
        ))}
      </div>
    </div>
  );
}

const styles = {
  pop: {
    position: "absolute",
    bottom: 46,
    left: 8,
    width: 240,
    background: "#fff",
    border: "1px solid #e3e6ee",
    borderRadius: 10,
    boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
    padding: 8,
    zIndex: 20,
  },
  tabs: { display: "flex", gap: 4, marginBottom: 6, borderBottom: "1px solid #f0f0f0", paddingBottom: 6 },
  tab: { border: "none", background: "none", fontSize: 16, cursor: "pointer", borderRadius: 6, padding: "2px 6px", opacity: 0.6 },
  tabActive: { opacity: 1, background: "#eef3ff" },
  grid: { display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2, maxHeight: 150, overflowY: "auto" },
  emoji: { border: "none", background: "none", fontSize: 18, cursor: "pointer", borderRadius: 6, padding: 3, lineHeight: 1 },
};
